export default function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale/src/colors.js
// module id = Vllo
// module chunks = 0